function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }
var id = 0;
function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }
import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
var _formatTable = _classPrivateFieldLooseKey("formatTable");
class RTEFormatter extends Component {
  constructor(...args) {
    super(...args);
    /**
     * Formats a table for easier styling
     * @param {HTMLTableElement} table
     */
    Object.defineProperty(this, _formatTable, {
      value: _formatTable2
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(_classPrivateFieldLooseBase(this, _formatTable)[_formatTable]);
  }
}
function _formatTable2(table) {
  const wrapper = document.createElement('div');
  wrapper.classList.add('rte-table-wrapper');
  const parent = table.parentNode;
  if (parent) {
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
}
if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
